import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const Arrow = (props) => {
    const { type, direction, light, size, ...safeProps } = props;

    const arrowIcon = () => {
        switch (size) {
            case 'small':
                return 'arrow4';
            default:
                return 'arrow2';
        }
    };
    return (
        <div
            {...safeProps}
            role="button"
            aria-label={direction}
            className={`
                arrow
                arrow--${type}
                arrow--${direction}
                arrow--${size}
                ${light ? 'arrow--light' : ''}
                ${props.className}
            `}
            onClick={props.onClick}>
            <Icon className="arrow__icon" name={arrowIcon()} />
        </div>
    );
};

Arrow.propTypes = {
    type: PropTypes.oneOf(['button', 'icon']),
    direction: PropTypes.oneOf(['next', 'prev']).isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    light: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'default']).isRequired,
};

Arrow.defaultProps = {
    type: 'icon',
    className: '',
    onClick: () => {},
    light: false,
    size: 'default',
};

export default Arrow;
